/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { auth, firestore } from '@/lib/firebase/firebase';
import { Button } from "__barrel_optimize__?names=Button!=!@mui/material";
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { doc, GeoPoint, getDoc, setDoc, Timestamp, updateDoc } from 'firebase/firestore';
import { useRouter } from 'next/navigation';
import React from 'react';
import toast from 'react-hot-toast';
import GoogleIcon from '@mui/icons-material/Google';
function SignInWithGoogle() {
    const router = useRouter();
    const handleGoogleLogin = async ()=>{
        const provider = new GoogleAuthProvider();
        toast.promise(new Promise(async (resolve, reject)=>{
            try {
                const signInResult = await signInWithPopup(auth, provider);
                const user = signInResult.user;
                const token = await user.getIdToken();
                const userRef = doc(firestore, 'users', user.uid);
                const userSnap = await getDoc(userRef);
                if (userSnap.exists()) {
                    const userData = userSnap.data();
                    const signInresponse = await fetch('/api/auth/sign-in', {
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            token: token
                        })
                    });
                    const responseData = await signInresponse.json();
                    if (signInresponse.ok && responseData.success) {
                        const userType = userData.user_type.toLowerCase();
                        const newHistoryEntry = {
                            last_login_time: Timestamp.now(),
                            user_agent: navigator.userAgent,
                            geo: responseData.lat && responseData.lon ? new GeoPoint(parseFloat(responseData.lat), parseFloat(responseData.lon)) : null
                        };
                        if (userData.history) {
                            await updateDoc(userRef, {
                                history: [
                                    ...userData.history,
                                    newHistoryEntry
                                ]
                            });
                        } else {
                            await updateDoc(userRef, {
                                history: [
                                    newHistoryEntry
                                ]
                            });
                        }
                        resolve('Successfully signed in!');
                        router.push("/".concat(userType));
                    } else {
                        router.push('/login');
                    }
                    return;
                } else {
                    const userData = {
                        first_name: user.displayName ? user.displayName.split(' ')[0] : '',
                        last_name: user.displayName ? user.displayName.split(' ').slice(1).join(' ') : '',
                        user_type: 'Customer',
                        created_at: Timestamp.now(),
                        history: [],
                        notifications: {
                            sms: true,
                            email: true
                        }
                    };
                    await setDoc(doc(firestore, 'users', user.uid), userData);
                    const signInresponse = await fetch('/api/auth/sign-in', {
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            token: token
                        })
                    });
                    const responseData = await signInresponse.json();
                    await updateDoc(userRef, {
                        history: [
                            {
                                last_login_time: Timestamp.now(),
                                user_agent: navigator.userAgent,
                                geo: responseData.lat && responseData.lon ? new GeoPoint(parseFloat(responseData.lat), parseFloat(responseData.lon)) : null
                            }
                        ]
                    });
                    if (signInresponse.ok && responseData.success) {
                        resolve('Successfully signed in!');
                        router.push('/customer');
                    }
                }
            } catch (error) {
                reject(error);
            }
        }), {
            loading: 'Loading',
            success: (s)=>s,
            error: 'Failed to login with Google'
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "mt-5",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center space-x-5",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex-1 bg-neutral-300 h-[1px]"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "-mt-1",
                        children: /*#__PURE__*/ _jsx("span", {
                            className: "text-neutral-500",
                            children: "or"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex-1 bg-neutral-300 h-[1px]"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mt-5",
                children: /*#__PURE__*/ _jsx(Button, {
                    fullWidth: true,
                    variant: "contained",
                    startIcon: /*#__PURE__*/ _jsx(GoogleIcon, {}),
                    size: "large",
                    onClick: handleGoogleLogin,
                    sx: {
                        textTransform: 'capitalize',
                        backgroundColor: 'var(--cyan)',
                        borderRadius: '8px',
                        fontFamily: 'Plus Jakarta Sans',
                        fontSize: '14px',
                        fontWeight: 500,
                        boxShadow: 'none'
                    },
                    children: "Log in with Google"
                })
            })
        ]
    });
}
export default SignInWithGoogle;
